import ReactQuill from 'react-quill';
import styled from 'styled-components';
import css from './editor.css';

const StyledEditor = styled(ReactQuill)`
  ${css};
`;

export default StyledEditor;
